/* import __COLOCATED_TEMPLATE__ from './collected-email-list.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();